import { render, staticRenderFns } from "./EditTestResult.vue?vue&type=template&id=c8251428&scoped=true&"
import script from "./EditTestResult.vue?vue&type=script&lang=js&"
export * from "./EditTestResult.vue?vue&type=script&lang=js&"
import style0 from "./EditTestResult.vue?vue&type=style&index=0&id=c8251428&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8251428",
  null
  
)

export default component.exports